export enum EAisDashboardCode {
    DOC_JOURNAL = 'DOC_JOURNAL', // Реестр документов
    SUMMARY_TRANSACTIONS_PROTOCOL_STATISTIC = 'SUMMARY_TRANSACTIONS_PROTOCOL_STATISTIC', // Сводный протокол операций
    REQUEST_STATISTIC_S4_S5 = 'REQUEST_STATISTIC_S4_S5', // Статистика запросов по С4, С5
    TOKEN_STATISTIC = 'TOKEN_STATISTIC', // Статус токена аутентификации
    SYSTEM_AVAILABILITY_STATUS = 'SYSTEM_AVAILABILITY_STATUS', // Статус доступности витрины
    REQUEST_STATISTIC_S3_S6_S12 = 'REQUEST_STATISTIC_S3_S6_S12', // Статус запросов по сценариям
    SYSTEM_UNAVAILABILITY = 'SYSTEM_UNAVAILABILITY', // Недоступность ИС НП
}
